import { useCallback, useRef, useState } from 'react';

export interface UseComboboxOptions {
  onDropdownOpen?: () => void;
  onDropdownClose?: () => void;
}

export interface ComboboxStore {
  dropdownOpened: boolean;
  openDropdown: () => void;
  closeDropdown: () => void;
  toggleDropdown: () => void;
}

export function useCombobox(options?: UseComboboxOptions): ComboboxStore {
  const [dropdownOpened, setDropdownOpened] = useState(false);

  // Keep callbacks in refs to avoid stale closures
  const onDropdownOpenRef = useRef(options?.onDropdownOpen);
  const onDropdownCloseRef = useRef(options?.onDropdownClose);
  onDropdownOpenRef.current = options?.onDropdownOpen;
  onDropdownCloseRef.current = options?.onDropdownClose;

  const openDropdown = useCallback(() => {
    setDropdownOpened((prev) => {
      if (!prev) {
        onDropdownOpenRef.current?.();
      }
      return true;
    });
  }, []);

  const closeDropdown = useCallback(() => {
    setDropdownOpened((prev) => {
      if (prev) {
        onDropdownCloseRef.current?.();
      }
      return false;
    });
  }, []);

  const toggleDropdown = useCallback(() => {
    setDropdownOpened((prev) => {
      if (prev) {
        onDropdownCloseRef.current?.();
        return false;
      } else {
        onDropdownOpenRef.current?.();
        return true;
      }
    });
  }, []);

  return {
    dropdownOpened,
    openDropdown,
    closeDropdown,
    toggleDropdown,
  };
}
